/* import __COLOCATED_TEMPLATE__ from './footer-inner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();